var map = {
	"./anestesia.png": 310,
	"./avi2.png": 1013,
	"./despacho.png": 242,
	"./gabinete.png": 311,
	"./icon_green.png": 1014,
	"./icon_red.png": 1015,
	"./icon_sage.png": 1016,
	"./icon_yellow.png": 1017,
	"./jpg2.png": 1018,
	"./logo.png": 1019,
	"./logo_2.png": 1020,
	"./logo_alaquas.png": 438,
	"./logo_massanassa.png": 439,
	"./pdf2.png": 1021,
	"./png2.png": 1022,
	"./sala_espera.png": 312,
	"./txt2.png": 1023,
	"./xls2.png": 1024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1012;